<template>
    <div class="cz2__checkout-item__boxes">
        <div v-if="specialBoxes && specialBoxes.length > 0">
            <h2
                id="cz2-box-heading"
                class="cz2__checkout-item__name"
            >
                {{$t('BOX_STYLE')}}
            </h2>

            <div
                role="radiogroup"
                aria-labelledby="cz2-box-heading"
                class="cz2__checkout-item__boxes__button__wrapper"
            >
                <label class="cz2__checkout-item__boxes__button">
                    <div class="cz2__checkout-item__boxes__button--row">
                        <div
                            :style="{ backgroundImage: `url(${imageLink(defaultBox)})` }"
                            class="cz2__checkout-item__boxes__button--image"
                        />

                        <div>
                            {{ defaultBox?.title }}
                        </div>
                    </div>

                    <input
                        type="radio"
                        name="boxStyle"
                        value="default"
                        :checked="!specialBoxSelected"
                        @click="removeSpecialBox"
                        class="cz2__checkout-item__boxes__radio"
                    >
                </label>

                <!-- Special boxes really _revert_ back from the special edition -->

                <label
                    v-for="box in specialBoxes"
                    :key="box.component.code"
                    class="cz2__checkout-item__boxes__button"
                    :data-index="box.index"
                >
                    <div class="cz2__checkout-item__boxes__button--row">
                        <div
                            :style="{ backgroundImage: `url(${imageLink(box)})` }"
                            class="cz2__checkout-item__boxes__button--image"
                        />

                        <div>
                            {{ box.header }}
                        </div>
                    </div>

                    <input
                        type="radio"
                        name="boxStyle"
                        :value="box.component.code"
                        :checked="box.selected"
                        @click="addBoxToCart(box)"
                        class="cz2__checkout-item__boxes__radio"
                    >
                </label>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__checkout-item__boxes {
            .cz2__checkout-item__name {
                margin-bottom: 4px;
            }

            .cz2__checkout-item__boxes__button__wrapper {
                display: flex;
                flex-direction: column;
                gap: 16px;
            }

            .cz2__checkout-item__boxes__button {
                position: relative;

                margin: 0;
                border-radius: 12px;
                padding-right: 16px;
                padding-left: 8px;

                height: 72px;
                width: 100%;

                display: flex;
                justify-content: space-between;
                align-items: center;

                background-color: rgba(255, 255, 255, 0.1);

                @include font(h3-secondary);
                color: white;

                .cz2__checkout-item__boxes__button--row {
                    display: flex;
                    align-items: center;
                    text-transform: none;
                }

                .cz2__checkout-item__boxes__button--image {
                    margin-right: 4px;

                    width: 40px;
                    height: 40px;

                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                }

                .cz2__checkout-item__boxes__button__price {
                    @include font(h3);
                    white-space: nowrap;
                }

                .cz2__checkout-item__boxes__radio {
                    position: absolute;
                    top: 0;
                    left: 0;
                    margin: 0;
                    padding: 0;

                    width: 100%;
                    height: 100%;

                    appearance: none;
                    outline: none;
                    cursor: pointer;

                    &:checked {
                        &:after {
                            content: '';

                            position: absolute;
                            left: 0;
                            top: -2px;

                            width: 100%;
                            height: 76px;

                            border: 4px solid color(secondaryYellow);
                            border-radius: 12px;
                        }
                    }
                }

                @include respond-above(md) {
                    height: 56px;

                    .cz2__checkout-item__boxes__radio {
                        &:checked {
                            &:after {
                                height: 60px;
                            }
                        }
                    }
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__checkout-item__boxes__button__wrapper {
            flex-direction: row;
        }
    }

    #cz2.cz2__is-sb {
        .cz2__checkout-item__boxes {
            .cz2__checkout-item__boxes__button {
                color: #000;
                background-color: #F8EBBB80;
            }
        }
    }
</style>

<script>
    import * as constants from '../constants';

    export default {
        data() {
            return {
                defaultBox: null,
            };
        },

        computed: {
            mainController() {
                return this.$store.state.customizer.mainController;
            },

            specialBoxes() {
                return this.$store.getters.specialBoxes;
            },

            specialBoxSelected() {
                return this.$store.getters.specialBoxes.find((x) => x.selected);
            },
        },

        mounted() {
            let boxes = this.mainController.findPlacement(constants.PLACEMENT_BOX);
            if (boxes == null) {
                boxes = this.mainController.findPlacement(constants.PLACEMENT_BOX_PACK);
            }

            let situationBox = null;

            // eslint-disable-next-line no-restricted-syntax
            for (const box of boxes.components) {
                if (this.mainController.isAvailable(box)) {
                    // Is it one of the special ones?
                    const special = this.specialBoxes.some((x) => x.component.code === box.code);

                    if (!special) {
                        situationBox = box;
                        break;
                    }
                }
            }

            if (situationBox) {
                this.defaultBox = {
                    code: situationBox.code,
                    image: situationBox.custom.image,
                    title: situationBox.custom['fun-box-title'] ?? this.$t('BOX_DEFAULT'),
                };
            }
        },

        methods: {
            addBoxToCart(box) {
                this.$store.dispatch('addSpecialBox', box);
            },

            removeSpecialBox() {
                this.$store.dispatch('removeSpecialBox');
            },

            imageLink(box) {
                const l = box?.image;

                if (l == null) {
                    return l;
                }

                if (l.startsWith('//')) {
                    return `https:${l}`;
                }

                return l;
            },
        },
    };
</script>
